<template>
  <v-dialog
    persistent
    :value="tieneDialogoAbierto"
    @input="cambiarVisibilidad"
    scrollable
    width="100%"
    max-width="700px"
  >
    <v-card>
      <v-card-title class="d-flex align-stretch flex-wrap">
        <v-col cols="12" sm="auto" class="pa-0 d-flex align-center">
          <span class="text-h6">{{ tituloFormulario }}</span>
        </v-col>

        <v-divider vertical class="mr-2 ml-3 hidden-xs-only" />

        <v-col class="pa-0 d-flex flex-column justify-center">
          <span class="custom-text">Estados</span>

          <div
            class="d-flex align-start align-md-center flex-wrap flex-column flex-md-row"
          >
            <v-checkbox
              v-if="convenio"
              disabled
              v-model="formData.disponible"
              label="Disponible"
              hide-details
              class="ma-0 mr-md-4 mb-1 mb-md-0"
            />

            <v-checkbox
              :disabled="bloqueoDeshabilitado"
              v-model="formData.bloqueado"
              label="Bloqueo cartera"
              hide-details
              class="ma-0 mb-1 mb-md-0"
              :color="formData.bloqueado === true ? 'red' : ''"
            />

            <div v-if="formData.embargo" class="mr-md-4 mb-1 mb-md-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    left
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    style="padding-bottom: 2px"
                    >info_outline</v-icon
                  >
                </template>
                <span>Empleado embargado</span>
              </v-tooltip>
            </div>

            <v-checkbox
              v-if="estaEditando"
              v-model="formData.estaRetirado"
              label="Empleado retirado"
              hide-details
              class="ma-0"
              :disabled="!puedeModificarCampos"
            />
          </div>
        </v-col>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div v-if="estaEditando && convenio">
          <h3 class="mt-2 mb-2 text-center">
            CARTERA PENDIENTE : {{ resultadoCartera }}
          </h3>
          <v-divider></v-divider>
        </div>
        <v-form ref="formulario" v-model="validacionFormulario">
          <v-row class="mt-2" align="start" dense>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="formData.tipoDocumento"
                label="Tipo Documento"
                :items="tiposDocumentos"
                item-text="DescTipoDocumento"
                item-value="_id"
                outlined
                dense
                :disabled="!puedeModificarCampos"
                :rules="getRules('required')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formData.numeroDocumento"
                label="Número Documento"
                maxlength="15"
                autocomplete="off"
                outlined
                dense
                :disabled="!puedeModificarCampos"
                :rules="getRules('required', 'numerico')"
                @blur="emitirValidarDocumento"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="formData.nombres"
                label="Nombres del empleado"
                autocomplete="off"
                outlined
                maxlength="50"
                dense
                :disabled="!puedeModificarCampos"
                class="my-input"
                :rules="getRules('required', 'soloLetrasYEspacios')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formData.primerApellido"
                label="Primer Apellido"
                autocomplete="off"
                outlined
                maxlength="50"
                dense
                :disabled="!puedeModificarCampos"
                class="my-input"
                :rules="getRules('required', 'soloLetrasYEspacios')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formData.segundoApellido"
                label="Segundo Apellido"
                autocomplete="off"
                outlined
                maxlength="50"
                dense
                :disabled="!puedeModificarCampos"
                class="my-input"
                :rules="getRules('soloLetrasYEspacios')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="formData.tipoContrato"
                label="Tipo Contrato"
                :items="tiposContratos"
                item-text="DescTipoContrato"
                item-value="_id"
                outlined
                dense
                :disabled="!puedeModificarCampos"
                :rules="getRules('required')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formData.cargo"
                label="Cargo"
                maxlength="70"
                autocomplete="off"
                outlined
                dense
                :disabled="!puedeModificarCampos"
                :rules="getRules('required')"
                class="my-input"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formData.telefono"
                label="Teléfono"
                autocomplete="off"
                outlined
                maxlength="10"
                dense
                :disabled="!puedeModificarCampos"
                :rules="getRules('required', 'numerico', 'telefonoCaracter')"
              ></v-text-field>
            </v-col>
            <v-col v-if="!estaEditando || puedeVerSalario" cols="12" sm="6">
              <v-text-field
                v-model="salarioVisual"
                label="Salario"
                prefix="$ "
                maxlength="15"
                autocomplete="off"
                outlined
                dense
                :disabled="!puedeModificarCampos"
                :rules="getRules('required', 'numericoFormateado')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formData.fechaIngreso | formatearFechaLocal"
                    readonly
                    label="Fecha Ingreso"
                    persistent-hint
                    append-icon="event"
                    clearable
                    dense
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :disabled="!puedeModificarCampos"
                    :rules="getRules('required')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.fechaIngreso"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formData.fechaContratoHasta | formatearFechaLocal"
                    readonly
                    label="Fecha Contrato hasta"
                    persistent-hint
                    append-icon="event"
                    clearable
                    dense
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :disabled="!puedeModificarCampos"
                    :rules="[reglaTipoContrato]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.fechaContratoHasta"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="formData.compania"
                label="Compañia"
                :items="empresas"
                item-text="razon_social"
                item-value="nit"
                @change="$emit('cambiar-compania', formData.compania)"
                return-object
                outlined
                dense
                clearable
                :disabled="!puedeModificarCampos"
                :rules="getRules('required')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="formData.sucursal"
                label="Sucursal"
                return-object
                :items="sucursales"
                item-text="DescripcionSucursal"
                item-value="IdSucursal"
                outlined
                dense
                clearable
                :disabled="!puedeModificarCampos"
                :rules="getRules('required')"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="btnCancelar white--text text-capitalize"
          @click="$emit('cancelar')"
        >
          Cancelar
        </v-btn>
        <v-btn
          v-if="
            (!estaEditando && puedeRegistrarEmpleado) ||
            (estaEditando && puedeEditarEmpleado)
          "
          class="btnAceptar white--text text-capitalize"
          @click="emitirGuardar"
        >
          {{ textoBoton }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  formatearNumero,
  parsearMoneda,
} from '../../../../utils/formatearMonedaUtil';
import { formatearFechaLocal } from '../../../../utils/formatearFechaUtil';
import { tienePermiso } from '../../../../utils/permisosUtil';
import { getRules } from '../../../../utils/validationsUtil';
import {
  construirDatosEmisionEmpleado,
  TIPO_CONTRATO,
} from '../Helper/empleadoHelper';
import { mapearEmpleadoAFormulario } from '../Helper/empleadoFormatoHelper';

const crearFormDataInicial = () => ({
  _id: '',
  compania: {},
  sucursal: null,
  bloqueado: false,
  disponible: false,
  nombres: '',
  primerApellido: '',
  segundoApellido: '',
  embargo: false,
  tipoDocumento: '',
  numeroDocumento: '',
  tipoContrato: '',
  cargo: '',
  telefono: '',
  fechaIngreso: '',
  fechaContratoHasta: '',
  salario: '',
  estaRetirado: false,
});

export default {
  filters: {
    formatearFechaLocal,
  },

  props: {
    tieneDialogoAbierto: Boolean,
    esEdicion: Boolean,
    convenio: Object,
    tiposDocumentos: Array,
    tiposContratos: Array,
    empresas: Array,
    sucursales: {
      type: Array,
      default: () => [],
    },
    resultadoCartera: {
      type: String,
      default: '',
    },
    puedeVerSalario: {
      type: Boolean,
      default: false,
    },
    puedeEditarEmpleado: {
      type: Boolean,
      default: false,
    },
    puedeRegistrarEmpleado: {
      type: Boolean,
      default: false,
    },
    puedeBloquearEmpleado: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formData: crearFormDataInicial(),
      validacionFormulario: true,
    };
  },

  computed: {
    estaEditando() {
      return this.esEdicion;
    },

    TIPOS_CONTRATO_TEMPORAL() {
      return [TIPO_CONTRATO.TERMINO_FIJO, TIPO_CONTRATO.OPS];
    },

    reglaTipoContrato() {
      return value =>
        this.TIPOS_CONTRATO_TEMPORAL.includes(this.formData.tipoContrato)
          ? !!value || 'El campo es obligatorio.'
          : true;
    },

    puedeModificarCampos() {
      return this.estaEditando
        ? this.puedeEditarEmpleado
        : this.puedeRegistrarEmpleado;
    },

    permitirDesbloqueoEmbargo() {
      return tienePermiso('desbloquearEmpleadoEmbargado');
    },

    bloqueoDeshabilitado() {
      if (!this.puedeModificarCampos) return true;
      if (!this.puedeBloquearEmpleado) return true;
      return this.formData.embargo && !this.permitirDesbloqueoEmbargo;
    },

    tituloFormulario() {
      return this.esEdicion ? 'Editar Empleado' : 'Registrar Empleado';
    },

    textoBoton() {
      return this.esEdicion ? 'Actualizar' : 'Guardar';
    },

    salarioVisual: {
      get() {
        return formatearNumero(this.formData.salario);
      },
      set(valor) {
        this.formData.salario = parsearMoneda(valor);
      },
    },
  },

  methods: {
    getRules,

    cambiarVisibilidad(dialogoVisible) {
      if (!dialogoVisible) this.$emit('cancelar');
    },

    abrirModal(empleado) {
      const datosEmpleado = mapearEmpleadoAFormulario(empleado, this.empresas);

      this.formData = {
        ...datosEmpleado,
        telefono: String(datosEmpleado.telefono ?? ''),
      };
    },

    cerrarModal() {
      this.limpiar();
    },

    emitirGuardar() {
      if (!this.$refs.formulario.validate()) return;

      this.$emit(
        'guardar',
        construirDatosEmisionEmpleado(this.formData, this.esEdicion)
      );
    },

    emitirValidarDocumento() {
      if (!this.formData.numeroDocumento || this.estaEditando) return;

      this.$emit('validar-documento', this.formData.numeroDocumento);
    },

    limpiar() {
      this.formData = crearFormDataInicial();
      this.$refs.formulario?.reset();
    },
  },
};
</script>

<style>
.rojo input[type='checkbox'] + .v-label {
  color: red;
}
.my-input input {
  text-transform: uppercase;
}
.custom-text {
  font-size: 15px;
  color: rgb(88, 88, 88);
}
</style>
